module.exports = __webpack_public_path__ + "img/a2.eddd7f2b.jpg";